module.exports = __webpack_public_path__ + "static/img/TheApartmentLoungeImage@2x.86fc4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/TheApartmentLoungeImage@2x.png
// module id = FYb0
// module chunks = 0